import request from "../request";

/**
 * 上传文件
 */
export const uploadFileApi = async (file: File): Promise<{ file: API.UploadFile }> => {
  const formData = new FormData();
  formData.append('file', file);
  return await request.post('/workbenchApi/uploads', formData);
};
